export default __webpack_public_path__ + "static/media/kaminfeuer_web-md@2x.0c1934f6.jpg";